import { InfiniteScroll, PageLoader } from '@american-autonomy/rantizo-ui';

import TeamMemberListItem from 'components/list-items/TeamMemberListItem';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TeamMemberList: FunctionComponent<Props> = ({
    hasMore = false,
    items,
    onNext,
    testId = TEST_ID
}) => (
    <InfiniteScroll
        className={styles.teamMemberList}
        fetchNextPage={onNext}
        hasNextPage={hasMore}
        loader={<PageLoader />}
        testId={testId}
    >
        {items.map((item, index) => (
            <TeamMemberListItem key={index} text={`${item.firstName} ${item.lastName}`} />
        ))}
    </InfiniteScroll>
);

export default TeamMemberList;
